/**
 * ADOBE CONFIDENTIAL
 * __________________
 * Copyright 2024 Adobe
 * All Rights Reserved.
 * __________________
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import { events } from '@adobe-commerce/event-bus';
import { ValuesModel } from '@/pdp/data/models';
import { getProductConfigurationValues } from '@/pdp/api';

export const setProductConfigurationValues = (
  callback: (prev: ValuesModel) => ValuesModel,
  options?: { scope?: string }
) => {
  const prev = getProductConfigurationValues({ scope: options?.scope });

  const next = callback(prev as ValuesModel);

  events.emit('pdp/values', { ...next }, { scope: options?.scope });
};
